import {UmpireSquadPlayerStats} from '../umpire-squad-player-stats';
import {UmpireIncident} from '../umpire-incident';
import {UmpireSquad} from '../umpire-squad';

export interface UmpireMatchSquadPlayerStats {
  id: string;

  type: string | undefined;

  start_time: string | undefined;

  relationshipNames: string[];

  home_squad: UmpireSquad;

  away_squad: UmpireSquad;

  incidents: UmpireIncident[];

  squad_player_stats: UmpireSquadPlayerStats[];
}
